export function useNavigationSearch(): UseNavigationSearchReturn {
    const { apiClient } = useShopwareContext();
    const { sessionContext } = useSessionContext();

    async function resolvePath(path: string) {
        if (path === "/") {
            // please ignore optional chaining for salesChannel object as it's always present (type definition issue)
            const categoryId =
                sessionContext.value?.salesChannel?.navigationCategoryId;

            return {
                routeName: "frontend.navigation.page",
                foreignKey: categoryId,
            } as Schemas["SeoUrl"];
        }

        const isTechnicalUrl =
            path.startsWith("/navigation/") ||
            path.startsWith("/detail/") ||
            path.startsWith("/landingPage/");

        // remove leading slash in case of seo url
        const normalizedPath = isTechnicalUrl ? path : path.substring(1);

        let seoResult = await apiClient.invoke("readSeoUrl post /seo-url", {
            body: {
                filter: [
                    {
                        type: "equals",
                        field: isTechnicalUrl ? "pathInfo" : "seoPathInfo",
                        value: normalizedPath,
                    },
                ],
            },
        });

        if((!seoResult.data.elements || seoResult.data.elements.length === 0) && !isTechnicalUrl)
        {
            seoResult = await apiClient.invoke("readSeoUrlIncludes post /seo-url", {
                body: {
                    filter: [
                        {
                            type: "contains",
                            field: "seoPathInfo",
                            value: normalizedPath,
                        },
                    ],
                },
            });
        }



        return seoResult.data.elements?.[0];
    }

    return {
        resolvePath,
    };
}
